// extracted by mini-css-extract-plugin
export default {"container":"SuggestedPrompts__container___iCixW"};